import { InferType, object, string } from 'yup'

export enum ProfileFields {
  email = 'email',
  username = 'username',
  password = 'password',
  passwordConfirm = 'passwordConfirm',
}

export const profileSettings = object({
  [ProfileFields.email]: string().required(),
  [ProfileFields.username]: string().required(),
  [ProfileFields.password]: string().optional(),
  [ProfileFields.passwordConfirm]: string().when({
    is: (password: string) => {
      return password?.length > 0
    },
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.optional().default(''),
  }),
})

export type ProfileSettingsSchema = InferType<typeof profileSettings>
/* 
is: (
  applicantEntitled: BooleanOptionsType,
  standardProgramEntitlementReason: StandardProgramEntitlementReason,
) => {
  return (
    applicantEntitled === BooleanOptionsType.yes &&
    standardProgramEntitlementReason === null
  )
},
then: (schema) => schema.required(),
otherwise: (schema) => schema.default(null), */
